{
  "content.actions.archive": "Archive",
  "content.actions.choose_cover": "Choose cover file",
  "content.actions.publish": "Publish",
  "content.actions.unpublish": "Unpublish",
  "content.article.actions.create": "Create article",
  "content.article.columns.actions": "Actions",
  "content.article.columns.featured": "Featured",
  "content.article.columns.status": "Status",
  "content.article.columns.title": "Article",
  "content.article.columns.updated": "Updated",
  "content.article.description": "Manage bilingual articles, categories, and publishing for the mobile experience.",
  "content.article.editor.create": "Create article",
  "content.article.editor.edit": "Edit article",
  "content.article.empty": "No articles match the filters",
  "content.article.body_format.blocks": "Structured content",
  "content.article.body_format.markdown": "Markdown",
  "content.article.fields.body": "Body",
  "content.article.fields.body_format": "Body format",
  "content.article.fields.category": "Category",
  "content.article.fields.cover": "Cover file",
  "content.article.fields.featured": "Featured article",
  "content.article.fields.reading_minutes": "Reading minutes",
  "content.article.fields.slug": "Slug",
  "content.article.fields.sort": "Sort order",
  "content.article.fields.status": "Status",
  "content.article.fields.summary": "Summary",
  "content.article.fields.title": "Title",
  "content.article.filters.category": "Category",
  "content.article.filters.landmark": "Article filters",
  "content.article.filters.q": "Search articles",
  "content.article.filters.sort": "Sort",
  "content.article.filters.status": "Status",
  "content.article.sort.published_at_desc": "Recently published",
  "content.article.sort.sort_order_asc": "Sort order",
  "content.article.sort.updated_at_desc": "Recently updated",
  "content.article.title": "Article management",
  "content.category.actions.create": "Create category",
  "content.category.columns.actions": "Actions",
  "content.category.columns.name": "Category",
  "content.category.columns.sort": "Order",
  "content.category.columns.status": "Status",
  "content.category.description": "Manage bilingual article category names, order, and status.",
  "content.category.editor.create": "Create category",
  "content.category.editor.edit": "Edit category",
  "content.category.empty": "No categories match the filters",
  "content.category.fields.description": "Description",
  "content.category.fields.name": "Name",
  "content.category.fields.slug": "Slug",
  "content.category.fields.sort": "Sort order",
  "content.category.fields.status": "Status",
  "content.category.filters.landmark": "Category filters",
  "content.category.filters.q": "Search categories",
  "content.category.filters.status": "Status",
  "content.category.status.active": "Active",
  "content.category.status.disabled": "Disabled",
  "content.category.title": "Category management",
  "content.delete.description": "This deletes “{name}” and cannot be undone.",
  "content.delete.title": "Delete this content?",
  "content.feedback.conflict": "Content was updated by another administrator. Refresh and try again.",
  "content.feedback.deleted": "Content deleted",
  "content.feedback.load_error": "Content data could not be loaded.",
  "content.feedback.published": "Article published",
  "content.feedback.save_error": "Content could not be saved. Try again.",
  "content.feedback.saved": "Content saved",
  "content.locales.en-US": "English content",
  "content.locales.zh-CN": "Simplified Chinese content",
  "content.states.refreshing": "Refreshing list…",
  "content.status.archived": "Archived",
  "content.status.draft": "Draft",
  "content.status.published": "Published",
  "content.tabs.articles": "Articles",
  "content.tabs.categories": "Categories",
  "content.validation.invalid": "Check the field values.",
  "content.values.no": "No",
  "content.values.none": "Not selected",
  "content.values.pending": "Pending sync",
  "content.values.yes": "Yes",
  "content.workbench.title": "Information workspace",
  "content.workbench.description": "Manage articles, galleries, videos, two-level categories, topics, tags, and comment moderation.",
  "content.tabs.topics": "Topics",
  "content.tabs.tags": "Tags",
  "content.tabs.comments": "Comments",
  "content.type.article": "Article",
  "content.type.gallery": "Gallery",
  "content.type.video": "Video",
  "content.article.fields.type": "Content type",
  "content.article.fields.categories": "Categories (up to 10)",
  "content.article.fields.topic": "Topic",
  "content.article.fields.tags": "Tags (up to 10)",
  "content.article.fields.comments": "Allow comments",
  "content.article.fields.pinned": "Pinned",
  "content.article.fields.latest": "Latest",
  "content.article.fields.gallery": "Gallery images (1–9)",
  "content.article.fields.video_source": "Video source",
  "content.article.columns.home": "Home attributes",
  "content.article.actions.add_image": "Add image",
  "content.article.actions.add_inline_image": "Add inline image",
  "content.article.actions.move_up": "Move image up",
  "content.article.actions.move_down": "Move image down",
  "content.article.actions.choose_video": "Choose video file",
  "content.video_source.upload": "Uploaded file",
  "content.video_source.external": "HTTPS URL",
  "content.category.fields.parent": "Parent category",
  "content.category.actions.choose_image": "Choose category image",
  "content.topic.title": "Topic management",
  "content.topic.actions.create": "Create topic",
  "content.topic.actions.choose_cover": "Choose topic cover",
  "content.topic.columns.name": "Topic",
  "content.topic.editor.edit": "Edit topic",
  "content.topic.fields.name": "Topic name",
  "content.topic.fields.description": "Topic description",
  "content.tag.title": "Tag management",
  "content.tag.fields.name": "Enter a tag such as AI",
  "content.tag.columns.name": "Tag",
  "content.tag.columns.usage": "Usage",
  "content.tag.actions.disable": "Disable",
  "content.tag.actions.enable": "Enable",
  "content.tag.actions.merge": "Merge into another tag",
  "content.comment.title": "Comment moderation",
  "content.comment.columns.author": "User",
  "content.comment.columns.body": "Comment",
  "content.comment.columns.status": "Status",
  "content.comment.columns.actions": "Moderation actions",
  "content.comment.status.pending": "Pending",
  "content.comment.status.approved": "Approved",
  "content.comment.status.rejected": "Rejected",
  "content.comment.status.hidden": "Hidden",
  "content.comment.status.deleted": "Deleted",
  "content.comment.actions.approve": "Approve",
  "content.comment.actions.reject": "Reject",
  "content.comment.actions.hide": "Hide",
  "content.comment.actions.batch_approve": "Approve selected",
  "content.comment.actions.batch_reject": "Reject selected",
  "content.comment.reports.title": "Comment reports",
  "content.comment.reports.reason": "Reason",
  "content.comment.reports.details": "Details",
  "content.comment.reports.resolve": "Resolve",
  "content.comment.reports.dismiss": "Dismiss",
  "content.comment.reports.dismissed": "Report dismissed",
  "content.comment.reasons.policy": "Does not meet community guidelines",
  "content.editor.toolbar": "Body editor toolbar",
  "content.editor.bold": "Bold",
  "content.editor.italic": "Italic",
  "content.editor.list": "List",
  "content.editor.quote": "Quote",
  "content.editor.code": "Code block",
  "content.article.editor.tabs.meta": "Meta information",
  "content.article.editor.tabs.content": "Content",
  "content.article.editor.tabs.commerce": "Products and membership",
  "content.article.preview.cover": "Article cover preview",
  "content.article.fields.video_external_url": "Video URL",
  "content.article.preview.title": "Content preview",
  "content.article.preview.loading": "Loading editor...",
  "content.article.actions.menu": "More",
  "content.article.actions.menu_for": "Actions for {name}",
  "content.tabs.moderation": "Comment review",
  "content.tabs.reports": "Reports",
  "content.manage.content": "Content",
  "content.manage.replyTo": "Reply to",
  "content.manage.parentUnavailable": "Original comment unavailable",
  "content.manage.created": "Submitted",
  "content.manage.details": "Details",
  "content.manage.reporter": "Reporter",
  "content.manage.resolveHide": "Uphold and hide",
  "content.manage.search": "Search comments, titles or users",
  "content.manage.allTypes": "All content types",
  "content.manage.allStatuses": "All statuses",
  "content.manage.allReasons": "All reasons",
  "content.manage.recordState": "Record state",
  "content.manage.live": "Not deleted",
  "content.manage.dateRange": "Submission date range",
  "content.manage.article_id": "Content ID",
  "content.manage.author_id": "Author ID",
  "content.manage.reporter_id": "Reporter ID",
  "content.manage.comment_id": "Comment ID",
  "content.manage.reset": "Reset filters",
  "content.manage.refresh": "Refresh",
  "content.manage.loadError": "Could not load. Refresh to retry.",
  "content.manage.invalidId": "Enter a valid UUID.",
  "content.manage.moderationReason": "Moderation reason",
  "content.manage.moderator": "Handled by",
  "content.manage.processedAt": "Handled at",
  "content.manage.resolution": "Resolution",
  "content.manage.reasonRequired": "Enter a resolution of 1–500 characters.",
  "content.manage.saved": "Saved. Lists updated.",
  "content.manage.actionConfirm": "Confirm action",
  "content.manage.deleteConfirm": "Confirm deletion",
  "content.manage.deleteReportHint": "The report will be marked deleted. Comment visibility will not change.",
  "content.manage.hideHint": "Only the author will see this comment. Other open reports for it will also be resolved.",
  "content.manage.confirmHint": "Apply this action to {count} selected record(s)?",
  "content.manage.reportStatus.open": "Open",
  "content.manage.reportStatus.resolved": "Upheld",
  "content.manage.reportStatus.dismissed": "Dismissed",
  "content.manage.reasons.spam": "Spam or advertising",
  "content.manage.reasons.abuse": "Abuse or harassment",
  "content.manage.reasons.illegal": "Illegal content",
  "content.manage.reasons.privacy": "Privacy violation",
  "content.manage.reasons.other": "Other",
  "content.manage.liveStatuses": "All non-deleted statuses",
  "content.manage.findContent": "Search content",
  "content.article.editor.fullscreen": "Enter fullscreen",
  "content.article.editor.exit_fullscreen": "Exit fullscreen"
}
